module.exports = __webpack_public_path__ + "img/australia-cerebrovascular-disease-female.1c25d995.png";